module.exports = __webpack_public_path__ + "img/lady-on-phone.fbf96399.png";